import {
  findSpend,
  getMapKey
} from '../supplier_datagrid/SupplierDataGridUtils';
import {
  SUPPLIER_STATUS_CONTROL,
  SUPPLIER_STATUS_DONOTUSE,
  SUPPLIER_STATUS_GROW,
  SUPPLIER_STATUS_LIMITED_USE,
  SUPPLIER_STATUS_MAINTAIN,
  SUPPLIER_STATUS_REDUCE
} from '../../shared/AppConstants';
import {
  addPropAndValueIfPresentAdd,
  getValueIfPresentElseZero
} from '../../shared/UtilFunctions';

function calcSpendTotal(allStatusSpendObj) {
  let total = 0;

  if (allStatusSpendObj) {
    total =
      getValueIfPresentElseZero(
        allStatusSpendObj[SUPPLIER_STATUS_GROW.toLowerCase()]
      ) +
      getValueIfPresentElseZero(
        allStatusSpendObj[SUPPLIER_STATUS_MAINTAIN.toLowerCase()]
      ) +
      getValueIfPresentElseZero(
        allStatusSpendObj[SUPPLIER_STATUS_CONTROL.toLowerCase()]
      ) +
      getValueIfPresentElseZero(
        allStatusSpendObj[SUPPLIER_STATUS_REDUCE.toLowerCase()]
      ) +
      getValueIfPresentElseZero(
        allStatusSpendObj[SUPPLIER_STATUS_LIMITED_USE.toLowerCase()]
      ) +
      getValueIfPresentElseZero(
        allStatusSpendObj[SUPPLIER_STATUS_DONOTUSE.toLowerCase()]
      );
  }
  return total;
}
/*
    If spendObj is present then the spend values are added and new spendObj is returned
   */
function getSpendObject(
  spendStatus,
  invoiceSpendAmt,
  forecastSpendAmt,
  spendObjOriginal
) {
  let spendObj = spendObjOriginal
    ? { ...spendObjOriginal }
    : { invoiceSpend: {}, forecastSpend: {} };
  let spendType = spendStatus.toLowerCase();

  addPropAndValueIfPresentAdd(
    spendObj.invoiceSpend,
    spendType,
    invoiceSpendAmt
  );
  addPropAndValueIfPresentAdd(
    spendObj.forecastSpend,
    spendType,
    forecastSpendAmt
  );
  return spendObj;
}

function findSupplierSpendBasedOnSupplierStatus(splr) {
  let spendStatus = getSupplierStatus(splr);

  return getSpendObject(spendStatus, splr.invoiceSpend, splr.forecastSpend);
}

function findUnitOrUnitGroupSpendObj(
  unitOrUnitGroupCode,
  status,
  supplierNumber,
  { masterInvoiceSpendMap, masterForecastSpendMap },
  spendObj
) {
  const mapKey = getMapKey(unitOrUnitGroupCode, supplierNumber);
  const invSpend = findSpend(masterInvoiceSpendMap, mapKey);
  const frcstSpend = findSpend(masterForecastSpendMap, mapKey);

  return getSpendObject(status, invSpend, frcstSpend, spendObj);
}
function findSpendForUnitExceptions(
  masterSpendObj,
  statusMap,
  supplierNumber,
  unitsSpendObj
) {
  const iterator = statusMap[Symbol.iterator]();
  let spendObj;

  if (unitsSpendObj) spendObj = { ...unitsSpendObj };

  for (const [unitCode, unitStatus] of iterator)
    spendObj = findUnitOrUnitGroupSpendObj(
      unitCode,
      unitStatus,
      supplierNumber,
      masterSpendObj,
      spendObj
    );

  return spendObj;
}

function addSpendAmounts(spendObj1, spendObj2) {
  let newSpendObj = { ...spendObj1 };

  for (const property in spendObj2)
    addPropAndValueIfPresentAdd(newSpendObj, property, spendObj2[property]);

  return newSpendObj;
}
function addSpends(spendObj1, spendObj2) {
  let newSpendObj;

  if (spendObj1 && spendObj2) {
    newSpendObj = { ...spendObj1 };

    newSpendObj.invoiceSpend = addSpendAmounts(
      newSpendObj.invoiceSpend,
      spendObj2.invoiceSpend
    );
    newSpendObj.forecastSpend = addSpendAmounts(
      newSpendObj.forecastSpend,
      spendObj2.forecastSpend
    );
  } else newSpendObj = spendObj1 || spendObj2;

  return newSpendObj;
}
/**
 * Calculates the Spend based on Supplier Spend and Exceptions Spend(s)
 *
 * @param {*} unitGroupsSpendObj
 * @param {*} unitGroupStatus*
 * @param {*} unitsSpendObj
 */
function calculateUnitGroupSpend(
  unitGroupsSpendObj,
  unitGroupStatus,
  unitsSpendObj
) {
  let spendObj;

  if (unitGroupsSpendObj && unitsSpendObj) {
    let status = unitGroupStatus.toLowerCase();
    let totalUnitsInvSpend = calcSpendTotal(unitsSpendObj.invoiceSpend);
    let totalUnitsFrcstSpend = calcSpendTotal(unitsSpendObj.forecastSpend);

    unitGroupsSpendObj.invoiceSpend[status] -= totalUnitsInvSpend;
    unitGroupsSpendObj.forecastSpend[status] -= totalUnitsFrcstSpend;

    spendObj = getSpendObject(
      status,
      unitGroupsSpendObj.invoiceSpend[status],
      unitGroupsSpendObj.forecastSpend[status],
      unitsSpendObj
    );
    // Add Unit Group Spend
  } else spendObj = unitGroupsSpendObj || unitsSpendObj;

  return spendObj;
}

function findSupplierSpendBasedOnExceptions(masterSpendObj, supplier) {
  const iterator = supplier.statusMap[Symbol.iterator]();
  let spendObj;

  for (const [unitGroupCode, unitGroupStatusObj] of iterator) {
    let unitsSpendObj;
    let unitGroupsSpendObj;

    if (unitGroupStatusObj.status) {
      // Exception on Group level
      unitGroupsSpendObj = findUnitOrUnitGroupSpendObj(
        unitGroupCode,
        unitGroupStatusObj.status,
        supplier.supplierNumber,
        masterSpendObj
        //unitGroupsSpendObj
      );
    }
    if (unitGroupStatusObj.statusMap && unitGroupStatusObj.statusMap.size > 0) {
      // Exception on Unit(s) level
      unitsSpendObj = findSpendForUnitExceptions(
        masterSpendObj,
        unitGroupStatusObj.statusMap,
        supplier.supplierNumber
        //unitsSpendObj
      );
    }

    let unitGroupNetSpendObj = calculateUnitGroupSpend(
      unitGroupsSpendObj,
      unitGroupStatusObj.status,
      unitsSpendObj
    );

    // Add current group spend to overall groups spend
    spendObj = addSpends(spendObj, unitGroupNetSpendObj);
  }

  return spendObj;
}

export function getSupplierStatus(splr) {
  return splr.status || splr.statusDesc;
}

/**
 * Calculates the Spend based on Supplier Spend and Exceptions Spend(s)
 *
 * @param {*} splrSpendObj
 * @param {*} unitGroupsSpendObj
 */
function calculateSpend(splrSpendObj, splrStatus, unitGroupsSpendObj) {
  let spendObj = { ...unitGroupsSpendObj };
  let totalUnitGroupsInvSpend = calcSpendTotal(unitGroupsSpendObj.invoiceSpend);
  let totalUnitGroupsFrcstSpend = calcSpendTotal(
    unitGroupsSpendObj.forecastSpend
  );

  let status = splrStatus.toLowerCase();

  splrSpendObj.invoiceSpend[status] -= totalUnitGroupsInvSpend;
  splrSpendObj.forecastSpend[status] -= totalUnitGroupsFrcstSpend;

  return addSpends(spendObj, splrSpendObj);
}

export function findSupplierSpend(masterSpendObj, supplier) {
  // Find Supplier Status Spend (required either way)
  let splrSpendObj = findSupplierSpendBasedOnSupplierStatus(supplier);
  let spendObj;

  if (masterSpendObj && supplier) {
    if (supplier.statusMap && supplier.statusMap.size > 0) {
      // Has Exceptions
      let unitGroupsSpendObj = findSupplierSpendBasedOnExceptions(
        masterSpendObj,
        supplier
      );

      spendObj = calculateSpend(
        splrSpendObj,
        getSupplierStatus(supplier),
        unitGroupsSpendObj
      );
    } else {
      // No Exceptions
      spendObj = splrSpendObj;
    }
  }
  return spendObj;
}

export function prepareSupplierMap(strategyInformation) {
  let map = new Map();

  if (strategyInformation) {
    strategyInformation.suppliers?.forEach((splr) =>
      map.set(splr.supplierNumber, splr)
    );
    // Order matters - this should be before nonStrategicSuppliers because nonStrategicSuppliers has spend info
    strategyInformation.nonStrategySupplierList?.forEach((splr) =>
      map.set(splr.supplierNumber, splr)
    );
    strategyInformation.nonStrategicSuppliers?.forEach((splr) =>
      map.set(splr.supplierNumber, splr)
    );
  }

  return map;
}
